import {connect} from 'react-redux';
import {getModel} from 'react-redux-form';
import classNames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';
import './styles/ControlGroup.scss';

class ControlGroup extends React.Component {

  //noinspection JSUnusedGlobalSymbols
  static contextTypes = {
    // model from rrf Form component
    model: PropTypes.any
  };

  static propTypes = {
    label: PropTypes.node,
    labelFor: PropTypes.string,
    showErrors: PropTypes.bool,
    checkbox: PropTypes.bool,
    radio: PropTypes.bool,
  };

  render() {
    const { label, labelFor, showErrors, children, className } = this.props;
    let { errors = null } = this.props;

    // Check RRF for errors if no errors are passed in
    if (errors == null) {
      errors = [];

      this.forEachControl(children, node => {
        errors = errors.concat(this.getErrors(node.props.model));
      });
    }

    return (
      <div className={classNames("control-group", className, {error: errors.length})}>
        {label && (<label className="control-label" htmlFor={labelFor}>{label}</label>)}
        <div className="controls">
          {children}
          {errors.length !== 0 && showErrors && (
            <div style={{marginTop: '4px'}}>
              {errors.map((e, index) => <div key={index}>{e}</div>)}
            </div>
          )}
        </div>
      </div>
    );
  }

  forEachControl(children, callback) {
    React.Children.forEach(children, node => {
      if (React.isValidElement(node)) {
        if (node.props.model) {
          callback(node);
        }
        this.forEachControl(node.props.children, callback);
      }
    });
  }

  getErrors(model) {
    const {fullState} = this.props;
    const path = this.resolveModel(model);
    const i = path.lastIndexOf('.');
    const errorPath = path.substring(0, i) + '.errors' + path.substring(i);
    let errors = getModel(fullState, errorPath, []);
    if (errorPath.endsWith('_id')) {
      errors = errors.concat(getModel(fullState, errorPath.substring(0, errorPath.length - 3), []));
    }
    return errors;
  }

  resolveModel(model) {
    const {fullState} = this.props;
    const {model: parentModel} = this.context;

    if (parentModel) {
      if (model[0] === '.' || model[0] === '[') {
        return `${parentModel}${model}`;
      }

      if (typeof model === 'function') {
        return model(fullState, parentModel);
      }
    }

    return model;
  }
}

export default connect(state => ({fullState: state}))(ControlGroup);
